module.exports = __webpack_public_path__ + "static/media/availability-01-01.66f0d0c0.svg";